import React from 'react';

import { TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';

interface Props {
  tmpValue: (key: string) => string | number;
  handleTmpChange: NonNullable<TextFieldProps['onChange']>;
  refund?: unknown;
  itemRefund?: unknown;
  itemRefundOriginal?: unknown;
}

export default function RefundAmount({ tmpValue, handleTmpChange }: Props) {
  return (
    <TextField
      id="PartialRefundVariant"
      label="Refund Amount to Customer"
      name="amount"
      value={tmpValue('amount')}
      onChange={handleTmpChange}
      fullWidth
    />
  );
}
